module.exports = __webpack_public_path__ + "static/apple-icon-120x120-46dd1e289f9d75ec68381e756c6725b4.png";